import Ad from "@components/Advertisement/Ad";
import AdSettings from "@components/Advertisement/AdSettings";
import Container from "@components/Container/Container";
import GAData from "@components/GAData/GAData";
import MetaTags from "@components/MetaTags/MetaTags";
import EEFooter from "@ee/components/EEFooterComponents/EEFooter";
import EventsAwardsHeader from "@events-awards/EventAwardsHeader";
import EventsAwardsNavigationBar from "@events-awards/EventsAwardsNavigationBarComponents/EventAwardsNavigationBar";
import {
  EVENTS_AWARDS_EE_LABEL,
  EVENTS_AWARDS_EE_PATH,
} from "@events-awards/utils/constants";
import {
  EEStaticPageFactory,
  getStaticPageTitle,
} from "@events-awards/utils/helpers";
import { AwardType } from "@events-awards/utils/types";
import { useDetectAdBlock } from "adblock-detect-react";

type EEStaticPageProps = {
  /** The url string to get url at EE static page. */
  urlPath: string;
};

/**
 * Component to render EE static navigation pages
 */
const EEStaticPage = ({ urlPath }: EEStaticPageProps): React.ReactElement => {
  const adBlockDetected = useDetectAdBlock();

  const StaticLayout = EEStaticPageFactory(urlPath);

  return (
    <div className="w-full" data-testid="ee-static-page-component">
      <AdSettings
        adNames={["lb1", "prestitial", "catfish"]}
        path={EVENTS_AWARDS_EE_PATH}
        adTargets={[{ key: "page", value: "listing" }]}
      />

      <GAData
        title="Emerging Enterprise Awards"
        chapter1="emerging enterprise"
        level2="events awards"
        adblocker={adBlockDetected ? 1 : 0}
      />

      <MetaTags
        title={getStaticPageTitle(urlPath) + "  - THE BUSINESS TIMES"}
        description={`THE BUSINESS TIMES ${EVENTS_AWARDS_EE_LABEL} - Find ${EVENTS_AWARDS_EE_LABEL} News & Headlines, insight and analysis in Singapore, ASBA-Pacific & global markets news at The Business Times.`}
        ogType="website"
        slug={EVENTS_AWARDS_EE_PATH}
      />

      <EventsAwardsHeader />

      <Container rootClassName="pb-8 w-full justify-center px-3 text-left text-gray-850">
        <EventsAwardsNavigationBar awardType={AwardType.EE} />

        <>{StaticLayout ? <StaticLayout /> : null}</>
      </Container>

      <EEFooter />

      <Ad adType="catfish" />

      <Ad adType="prestitial" />
    </div>
  );
};

export default EEStaticPage;
